<form [formGroup]="form">
  <formly-form
    [model]="model"
    [fields]="fields"
    [options]="options"
    [form]="form"
    (modelChange)="modelChange.emit($event)"
  >
  </formly-form>
</form>


// WEBPACK FOOTER //
// ./src/app/shared/components/schema-form/schema-form.component.html